import React, { useState } from 'react';
import { XIcon, AlertCircleIcon, CheckCircleIcon, InfoIcon, AlertTriangleIcon } from 'lucide-react';
interface AlertProps {
  variant?: 'info' | 'success' | 'warning' | 'error';
  title?: string;
  children: React.ReactNode;
  dismissible?: boolean;
  className?: string;
}
const Alert: React.FC<AlertProps> = ({
  variant = 'info',
  title,
  children,
  dismissible = false,
  className = ''
}) => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) {
    return null;
  }
  const variantStyles = {
    info: {
      container: 'bg-blue-50 border-blue-200 text-blue-800',
      icon: <InfoIcon className="h-5 w-5 text-blue-500" data-id="element-556" />
    },
    success: {
      container: 'bg-green-50 border-green-200 text-green-800',
      icon: <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-557" />
    },
    warning: {
      container: 'bg-yellow-50 border-yellow-200 text-yellow-800',
      icon: <AlertTriangleIcon className="h-5 w-5 text-yellow-500" data-id="element-558" />
    },
    error: {
      container: 'bg-red-50 border-red-200 text-red-800',
      icon: <AlertCircleIcon className="h-5 w-5 text-red-500" data-id="element-559" />
    }
  };
  return <div className={`${variantStyles[variant].container} border rounded-md p-4 ${className}`} data-id="element-560">
      <div className="flex" data-id="element-561">
        <div className="flex-shrink-0 mr-3" data-id="element-562">{variantStyles[variant].icon}</div>
        <div className="flex-1" data-id="element-563">
          {title && <h3 className="text-sm font-medium mb-1" data-id="element-564">{title}</h3>}
          <div className="text-sm" data-id="element-565">{children}</div>
        </div>
        {dismissible && <div className="ml-auto pl-3" data-id="element-566">
            <button onClick={() => setDismissed(true)} className="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-567">
              <XIcon className="h-5 w-5" data-id="element-568" />
            </button>
          </div>}
      </div>
    </div>;
};
export default Alert;